import { Dispatch, SetStateAction, useEffect, useMemo, useRef } from 'react'
import { Lookup } from 'src/common/Common.Type'
import DropDown from 'src/component/DropDown'
import Field from 'src/component/field'
import { useTranslation } from 'react-i18next'
import { useCalcCost } from 'src/hooks/CommonUse/useCalcCost'
import CostTag from 'src/component/CostTag'

import { RepeatedDoses, userDose } from './DynamisServiceCard'
import DataState from 'src/component/DataState/DataState'
import MedicineCostSkeleton from './MedicineCostSkeleton'
import { patientDecisionMedicine, RepeatedDosesType } from 'src/types/DoctorScreens/DoctorOrders'

import "./style.css"
import { PharmacyMedicineType } from 'src/types/Requests/MobShared/HospitalMedicines'

interface IDataRow {
    setData: Dispatch<SetStateAction<any>>
    index: number
    rowItem: any,
    data: any
    medicinesList: any[]
    decisionId: number | null
    hospitalId: number | null
    isResritctMedicineAllDecisionPeriod?: boolean
    setNotAvailableMap: Dispatch<SetStateAction<Record<number, boolean>>>
}

const DataRow = ({
    rowItem,
    setData,
    index,
    medicinesList,
    decisionId,
    hospitalId,
    data,
    setNotAvailableMap,
    isResritctMedicineAllDecisionPeriod,
}: IDataRow) => {
    const { t } = useTranslation()
    console.log({ rowItem })
    const isAllowAllTouched = useRef<boolean>(false)

    const { data: medicineResult, loading: checkingMedicine } = useCalcCost(rowItem, decisionId, hospitalId)
    const isNotAvalilable = useMemo(
        () => medicineResult?.remainaingAmount === 0
            && medicineResult?.totalAmount === 0
            && !checkingMedicine && !!rowItem?.sMedicine?.value,
        [rowItem?.sMedicine, checkingMedicine, medicineResult]
    )

    useEffect(() => {
        setNotAvailableMap(prev => ({
            ...prev,
            [index]: isNotAvalilable
        }))
    }, [index, isNotAvalilable])

    useEffect(() => {
        setData((prev: patientDecisionMedicine[]) =>
            prev.map((item: patientDecisionMedicine) => {
                if (isResritctMedicineAllDecisionPeriod && item.isNewItem) {
                    return {
                        ...item,
                        durationType: RepeatedDoses[3],
                        allowsAllDurations: true
                    }
                }
                return item
            })
        )
    }, [])

    const handleChange = (key: string, value: Lookup | null | "" | boolean | PharmacyMedicineType) => {
        setData((prev: patientDecisionMedicine[]) =>
            prev.map((item: patientDecisionMedicine, i: number) =>
                i === index
                    ?
                    {
                        ...item,
                        [key]: value
                    }
                    : item
            )
        )
    }

    const isDurationDisabled =
        (!isAllowAllTouched.current) &&
        ((isResritctMedicineAllDecisionPeriod && rowItem?.isNewItem) ||
            (isResritctMedicineAllDecisionPeriod && rowItem?.allowsAllDurations && !rowItem?.isNewItem))

    const handleActiveDuration = (sOption: any) => {
        if (isDurationDisabled) return
        handleChange("duration", sOption?.repeat)
        handleChange("durationType", sOption)
        handleChange("allowsAllDurations", sOption?.allowsAllDurations)
    }

    return (
        <div className={`add-medicines-doc row  ${isNotAvalilable ? 'no-available' : ""}`}>
            <DataState
                isEmpty={isNotAvalilable}
                emptyState={<span> {t("no-avilable")} </span>}
                isLoading={checkingMedicine}
                skeleton={<MedicineCostSkeleton />}
            >
                <div className='col-md-11'>
                    <div className='row justify-content-center align-items-center'>
                        {medicineResult?.monthlyAmount ? <CostTag amount={medicineResult?.monthlyAmount} title={"total-amount"} /> : ""}
                        {medicineResult?.medicinePrice * medicineResult?.monthlyAmount ?
                            <CostTag amount={medicineResult?.medicinePrice * medicineResult?.monthlyAmount} title={"total-cost"} /> : ""
                        }
                    </div>
                </div>
            </DataState>

            <div className='col-md-6 col-sm-12'
            >
                <DropDown
                    label={'medicine'}
                    options={medicinesList}
                    setVal={(sOption: Lookup) => handleChange('sMedicine', sOption)}
                    val={rowItem["sMedicine"]}
                />
                {
                    data?.[index]?.sMedicine && !data?.[index]?.sMedicine?.isInStock &&
                    <div className='small text-danger'>
                        {t("medicine-has-empty-stock")}
                    </div>
                }
            </div>
            <Field
                className='col-md-6 col-sm-12'
                label='doseAmount'
                setValue={value => handleChange('dosePerDay', value)}
                value={rowItem["dosePerDay"]}
            />
            <Field
                className='col-md-6 col-sm-12'
                label='doseRequest'
                setValue={value => handleChange('doseCountPerTime', value)}
                value={rowItem["doseCountPerTime"]}
            />
            <DropDown
                className='col-md-6 col-sm-12'
                label={'user-dose-repeat'}
                options={userDose}
                setVal={(sOption: Lookup) => handleChange('sDoseType', sOption)}
                val={rowItem["sDoseType"]}
            />
            {!rowItem?.allowsAllDurations
                && <Field
                    className='col-md-3 col-sm-12'
                    label='duration'
                    setValue={value => handleChange('duration', value)}
                    value={rowItem["duration"]}
                />
            }

            <div className='col-md-9 col-sm-12 repeating-section'>
                {RepeatedDoses.map((item: RepeatedDosesType) => {
                    return (
                        <div
                            className={`pointer ${rowItem["durationType"]?.value == item.value ? 'selected' : ""} 
                            ${(isDurationDisabled) ? "disabled" : ""}`
                            }
                            onClick={() => { handleActiveDuration(item); isAllowAllTouched.current = true }}
                            key={item.value}
                        >
                            {t(item.label)}
                        </div>
                    )
                })}
            </div>

            {rowItem?.sMedicine?.allowDirectAmount
                && <Field
                    className='col-md-6 col-sm-12'
                    label='directionAmount'
                    setValue={value => handleChange('directAmount', value)}
                    value={rowItem["directAmount"]}
                />
            }
        </div>
    )
}

export default DataRow


